// extracted by mini-css-extract-plugin
export default {"creditsPillContainer":"T2MNYIlL9IIxMsyR9wwW","small":"UNWCypxQZxFq_nAAgN6r","medium":"ye7XPjjbDok63miwtijd","premium":"Vl1KNcbG_WVHN6EYvxVl","error":"VoSmz66m6Y0H6TRBDTtX"};